export default ({ ["styles"] : ({ ["global"] : ({ [":root"] : ({  }), ["body"] : ({  }) }) }) })